var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_705_5620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 32,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4704 2.18756H1.71655V32.9414H32.4704V2.18756Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_705_5620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0102 17.5645C32.0102 25.8028 25.3318 32.4812 17.0935 32.4812C8.8552 32.4812 2.17677 25.8028 2.17677 17.5645C2.17677 9.32621 8.85521 2.64777 17.0935 2.64777C25.3318 2.64777 32.0102 9.32621 32.0102 17.5645Z",
    fill: "#F3BA2F",
    stroke: "white",
    strokeWidth: 0.920426
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3621 16.0307L17.0948 12.2979L20.8295 16.0326L23.0015 13.8606L17.0948 7.95392L11.1901 13.8587L13.3621 16.0307ZM7.48425 17.5645L9.65625 15.3925L11.8282 17.5645L9.65625 19.7365L7.48425 17.5645ZM13.3621 19.0984L17.0948 22.8311L20.8295 19.0964L23.0015 21.2675L17.0948 27.1751L11.1901 21.2703L11.1872 21.2675L13.3621 19.0984ZM22.3614 17.5645L24.5334 15.3925L26.7054 17.5645L24.5334 19.7365L22.3614 17.5645ZM19.2976 17.5626H19.2995V17.5645L17.0948 19.7692L14.8931 17.5683L14.8892 17.5645L14.8931 17.5616L15.2784 17.1753L15.4658 16.9879L17.0948 15.3598L19.2985 17.5635L19.2976 17.5626Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.095f0d78f12a33102f59ac63ec902b75.svg";
export { ForwardRef as ReactComponent };